// src/components/About.js
import React from 'react';

const previewCards = [
  {
    badge: 'NEW',
    title: 'Новые анонсы',
    text: 'Свежие находки, акции и выгодные предложения каждый день.',
    href: 'https://t.me/shoptop_brands',
  },
  {
    badge: 'USA',
    title: 'Америка',
    text: 'Официальные магазины, бренды, распродажи и закрытые sale.',
    href: 'https://t.me/shoptop_brands',
  },
  {
    badge: 'EU',
    title: 'Европа',
    text: 'Выкупы из европейских магазинов, аутлетов и private sale.',
    href: 'https://t.me/shoptop_brands',
  },
  {
    badge: 'SALE',
    title: 'Sale / Outlet',
    text: 'Самые интересные скидки, лимитированные акции и быстрые выкупы.',
    href: 'https://t.me/shoptop_brands',
  },
  {
    badge: 'UNIQLO',
    title: 'Uniqlo Europe',
    text: 'Подборки, размеры и актуальные позиции из европейских коллекций.',
    href: 'https://t.me/shoptop_brands',
  },
  {
    badge: 'GO',
    title: 'Все каналы',
    text: 'Telegram, MAX и WhatsApp — выбирайте удобную площадку.',
    href: 'https://max.ru/id540860074774_biz',
  },
];

const About = () => {
  return (
    <section className="container about-section catalog-preview-section">
      <div className="catalog-preview">
        <div className="catalog-preview-text">
          <p className="catalog-preview-kicker">Витрина SHOPTOP BRANDS</p>

          <h2>Актуальные анонсы и подборки</h2>

          <p className="catalog-preview-lead">
            Каждый день собираем выгодные предложения из США и Европы:
            официальные магазины, аутлеты, закрытые распродажи и лимитированные акции.
          </p>

          <p className="catalog-preview-note">
            Сейчас самые свежие анонсы публикуем в каналах, а позже здесь появится
            полноценный каталог с подборками, карточками товаров и быстрым переходом к заказу.
          </p>

          <div className="catalog-preview-actions">
            <a
              className="catalog-preview-main-link"
              href="https://t.me/shoptop_brands"
              target="_blank"
              rel="noreferrer"
            >
              Смотреть Telegram
            </a>

            <a
              className="catalog-preview-secondary-link"
              href="https://max.ru/id540860074774_biz"
              target="_blank"
              rel="noreferrer"
            >
              Смотреть MAX
            </a>
          </div>
        </div>

        <div className="catalog-preview-grid">
          {previewCards.map((card) => (
            <a
              key={card.title}
              className="catalog-preview-card"
              href={card.href}
              target="_blank"
              rel="noreferrer"
            >
              <div className="catalog-preview-card-top">
                <span className="catalog-preview-badge">{card.badge}</span>
                <span className="catalog-preview-card-title">{card.title}</span>
              </div>

              <p>{card.text}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
